import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IdService {

  private sequentialIdNamespaceObject: Record<string, number> = {};
  /**
   * Generates UUID string
   */
  static getUUID(): string {
    const part1 = IdService.getRandomStringPart(false);
    const part2 = IdService.getRandomStringPart(true);
    const part3 = IdService.getRandomStringPart(true);
    const part4 = IdService.getRandomStringPart(false);
    return part1 + part2 + part3 + part4;
  }

  /**
   *  Generates random string 4 characters long prepending dash if addSeparator argument is true
   */
  private static getRandomStringPart(addSeparator: boolean): string {
    const p = (Math.random().toString(16) + '000000000').substr(2, 8);
    return addSeparator ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
  }

  /**
   * Generate a sequential ID based on a namespace that is passed in via parameter, returns  increments the number.
   *
   * @param namespace The namespace that the sequential id belongs to
   * @returns The sequential id
   */
  generateNamespaceSequentialId(namespace: string): string {
    if (this.sequentialIdNamespaceObject[namespace] === undefined) {
      this.sequentialIdNamespaceObject[namespace] = 0;
    }
    return `${namespace}-${this.sequentialIdNamespaceObject[namespace]++}`;
  }
}
